import socialNetwork from "./SocialNetwork";
import ImageCanvasTools_Prd from "./ImageCanvasTools_Prd";
import ImageCropper from "./ImageCropper";
import ImageUploader from "./ImageUploader";

export default {
  ...socialNetwork,
  ImageCanvasTools_Prd,
  ImageCropper,
  ImageUploader,
};
